/* NuevArt / Impulse 9.2. Cart totals always come from Shopify, never simulated. */
(function () {
  'use strict';
  if (window.NuevartCommerce) return;
  var Core = window.NuevartCommerceCore;
  var configNode = document.getElementById('NuevartCommerceConfig');
  if (!Core || !configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  var state = { item_count: 0, eligible_quantity: 0, bogo_savings: 0, items: [] };
  var rails = new Map();
  var observedForms = new WeakSet();
  var requests = new Map();
  var boundDrawers = new WeakSet();
  var lastRewardEvent = '';
  var headerObserver;
  function json(node, fallback) { try { return JSON.parse(node.textContent); } catch (_) { return fallback; } }
  function string(key) { return (config.strings || {})[key] || ''; }
  function shopURL(path) {
    var url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('Invalid storefront URL');
    return url;
  }
  function imageURL(value) {
    if (value && typeof value === 'object') value = value.src || value.url;
    if (!value) return null;
    try {
      var url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:' && !(url.origin === window.location.origin && url.protocol === 'http:')) return null;
      if (url.origin !== window.location.origin && url.hostname !== 'cdn.shopify.com' && !url.hostname.endsWith('.shopify.com') && !url.hostname.endsWith('.shopifycdn.net')) return null;
      url.searchParams.set('width', '440');
      return url.href;
    } catch (_) { return null; }
  }
  function money(cents) {
    try { return new Intl.NumberFormat(config.locale || document.documentElement.lang || 'en', { style: 'currency', currency: state.currency || config.currency || 'USD' }).format((Number(cents) || 0) / 100); }
    catch (_) { return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + (state.currency || config.currency || ''); }
  }
  function track(name, detail) {
    if (!config.analytics) return;
    try {
      if (!window.Shopify || !Shopify.customerPrivacy || !Shopify.customerPrivacy.analyticsProcessingAllowed()) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, detail));
    } catch (_) { /* No consent provider means no tracking. */ }
  }
  async function get(url, type) {
    var key = String(url) + '|' + type;
    var prior = requests.get(key);
    if (prior && Date.now() - prior.time < 120000) return prior.promise;
    if (requests.size > 40) requests.delete(requests.keys().next().value);
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 8000);
    var promise = fetch(url, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: type === 'json' ? 'application/json' : 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed: ' + response.status);
        return type === 'json' ? response.json() : response.text();
      }).finally(function () { clearTimeout(timer); }).catch(function (error) { requests.delete(key); throw error; });
    requests.set(key, { time: Date.now(), promise: promise });
    return promise;
  }
  function readCandidates(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var el = parsed.querySelector('[data-nv-candidates]');
    var data = el ? json(el, []) : [];
    return Array.isArray(data) ? data : [];
  }
  async function candidates(seeds) {
    var jobs = [];
    var tags = Core.meaningfulTags(seeds, config);
    if (tags.length) {
      var search = shopURL(config.searchUrl || config.root + 'search');
      search.searchParams.set('type', 'product');
      search.searchParams.set('view', 'nuevart-recommendations');
      search.searchParams.set('options[unavailable_products]', 'hide');
      search.searchParams.set('options[prefix]', 'none');
      search.searchParams.set('q', Core.searchQuery(tags));
      jobs.push(get(search, 'html').then(readCandidates));
    }
    seeds.slice(0, 2).forEach(function (product) {
      var url = shopURL((config.recommendationsUrl || config.root + 'recommendations/products').replace(/\.json$/, '') + '.json');
      url.searchParams.set('product_id', String(product.id));
      url.searchParams.set('limit', '10');
      url.searchParams.set('intent', 'related');
      jobs.push(get(url, 'json').then(function (data) { return data.products || []; }));
    });
    var results = await Promise.allSettled(jobs);
    return (config.manualProducts || []).concat.apply(config.manualProducts || [], results.map(function (r) { return r.status === 'fulfilled' && Array.isArray(r.value) ? r.value : []; }));
  }
  function cartProductIDs() { return state.items.map(function (item) { return String(item.product.id); }); }
  function uniqueProducts(items) {
    var seen = new Set();
    return items.map(function (i) { return i.product; }).filter(function (p) { if (!p || seen.has(String(p.id))) return false; seen.add(String(p.id)); return true; });
  }
  function isCartOpen(el) {
    var drawer = el.closest('#CartDrawer');
    return !drawer || drawer.classList.contains('drawer--is-open');
  }
  function card(product, context) {
    var li = document.createElement('li');
    li.className = 'nv-rec-card';
    var href;
    try { href = shopURL(product.url || config.root + 'products/' + encodeURIComponent(product.handle)); } catch (_) { return null; }
    var visual = document.createElement('a');
    visual.href = href.href;
    visual.className = 'nv-rec-card__image';
    visual.tabIndex = -1;
    visual.setAttribute('aria-hidden', 'true');
    var src = imageURL(product.featured_image);
    if (src) {
      var image = document.createElement('img');
      image.src = src; image.alt = ''; image.width = 160; image.height = 160;
      image.loading = 'lazy'; image.decoding = 'async';
      image.addEventListener('error', function () { image.remove(); }, { once: true });
      visual.appendChild(image);
    }
    var body = document.createElement('div'); body.className = 'nv-rec-card__body';
    var title = document.createElement('a'); title.href = href.href; title.className = 'nv-rec-card__title'; title.textContent = product.title;
    var price = document.createElement('p'); price.className = 'nv-rec-card__price';
    price.textContent = (product.price_varies ? string('from') + ' ' : '') + money(product.price);
    var action = document.createElement('a'); action.href = href.href; action.className = 'nv-rec-card__action';
    action.textContent = string('chooseOptions'); action.setAttribute('aria-label', string('chooseOptions') + ': ' + product.title);
    body.append(title, price, action); li.append(visual, body);
    li.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { track('nv_recommendation_click', { product_id: String(product.id), placement: context }); });
    });
    return li;
  }
  class Recommendations {
    constructor(el) {
      this.el = el; this.context = el.dataset.nvContext; this.rail = el.querySelector('[data-nv-rail]');
      this.prev = el.querySelector('[data-nv-prev]'); this.next = el.querySelector('[data-nv-next]');
      this.seed = json(el.querySelector('[data-nv-seed]'), null); this.visible = this.context !== 'product';
      this.version = 0; this.signature = '';
      var move = (direction) => { var rtl = document.documentElement.dir === 'rtl' ? -1 : 1; this.rail.scrollBy({ left: this.rail.clientWidth * 0.88 * direction * rtl, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); };
      this.prev.addEventListener('click', () => move(-1)); this.next.addEventListener('click', () => move(1));
      this.rail.addEventListener('scroll', () => this.arrows(), { passive: true });
      if ('ResizeObserver' in window) { this.resize = new ResizeObserver(() => this.arrows()); this.resize.observe(this.rail); }
      if (this.context === 'product' && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => { if (entries.some((entry) => entry.isIntersecting)) { this.visible = true; this.observer.disconnect(); this.refresh(); } }, { rootMargin: '300px' });
        this.observer.observe(el.parentElement);
      } else this.visible = true;
      this.refresh();
    }
    arrows() {
      var distance = Math.abs(this.rail.scrollLeft);
      this.prev.disabled = distance < 2;
      this.next.disabled = distance + this.rail.clientWidth >= this.rail.scrollWidth - 2;
    }
    dispose() { this.version++; if (this.resize) this.resize.disconnect(); if (this.observer) this.observer.disconnect(); }
    async refresh() {
      if (!this.el.isConnected || !this.visible || !isCartOpen(this.el)) return;
      var isProduct = this.context === 'product';
      if (!isProduct && !state.item_count) { this.el.hidden = true; this.signature = ''; this.version++; return; }
      var seeds = isProduct && this.seed ? [this.seed] : uniqueProducts(state.items);
      var exclude = cartProductIDs();
      var signature = JSON.stringify([seeds.map((p) => [p.id, p.tags]), exclude.sort(), state.currency]);
      if (signature === this.signature) return;
      this.signature = signature;
      var version = ++this.version;
      this.el.setAttribute('aria-busy', 'true');
      try {
        var pool = await candidates(seeds);
        var selected = Core.rankCandidates(pool, seeds, exclude, config);
        if (selected.length < config.limit && config.fallbackUrl) {
          var fallback = shopURL(config.fallbackUrl); fallback.searchParams.set('view', 'nuevart-recommendations');
          try { pool = pool.concat(readCandidates(await get(fallback, 'html'))); } catch (_) { /* Keep any good results already received. */ }
          selected = Core.rankCandidates(pool, seeds, exclude, config);
        }
        if (version !== this.version || !this.el.isConnected) return;
        // Recheck current cart IDs after asynchronous work; never suggest an item just added.
        selected = Core.rankCandidates(selected, seeds, cartProductIDs(), config);
        var fragment = document.createDocumentFragment();
        selected.forEach((product) => { var el = card(product, this.context); if (el) fragment.append(el); });
        this.rail.replaceChildren(fragment); this.rail.scrollLeft = 0;
        this.el.hidden = this.rail.children.length === 0;
        if (this.el.hidden) this.signature = ""; // Retry after a later cart update or drawer open.
        this.arrows();
        if (!this.el.hidden) track('nv_recommendation_view', { placement: this.context, product_ids: selected.map((p) => String(p.id)) });
      } catch (_) {
        if (version === this.version) { this.el.hidden = true; this.signature = ''; }
      } finally { if (version === this.version) this.el.removeAttribute('aria-busy'); }
    }
  }
  function renderRewards() {
    var reward = Core.rewardState(state.eligible_quantity, config.cap);
    document.querySelectorAll('[data-nv-rewards]').forEach(function (el) {
      var message = el.querySelector('[data-nv-reward-message]');
      message.textContent = reward.needed === 1 ? string('addOne') : reward.needed ? string('addMore').replace('[count]', String(reward.needed)) : string('allSets');
      var progress = el.querySelector('[data-nv-progress]');
      progress.setAttribute('aria-valuemax', String(reward.maximum));
      progress.setAttribute('aria-valuenow', String(Math.min(reward.quantity, reward.maximum)));
      progress.setAttribute('aria-valuetext', reward.quantity + ' / ' + reward.maximum);
      el.querySelector('[data-nv-progress-fill]').style.width = reward.progress + '%';
      el.querySelectorAll('[data-nv-milestone]').forEach(function (item) { item.classList.toggle('is-reached', reward.quantity >= Number(item.dataset.nvMilestone)); });
      var status = el.querySelector('[data-nv-reward-confirmation]');
      status.hidden = !reward.sets && !(state.bogo_savings > 0);
      status.textContent = state.bogo_savings > 0 ? string('applied') : string('pending');
      status.classList.toggle('is-applied', state.bogo_savings > 0);
    });
    document.querySelectorAll('[data-nv-cart-count]').forEach(function (el) { el.textContent = '(' + state.item_count + ')'; });
    if (config.bogoEnabled && lastRewardEvent !== String(reward.sets)) {
      lastRewardEvent = String(reward.sets);
      track('nv_bogo_progress', { completed_sets: reward.sets, eligible_quantity: reward.quantity });
    }
  }
  function applyState(data) {
    if (!data || !Array.isArray(data.items)) return;
    state = data; renderRewards(); rails.forEach(function (rail) { rail.refresh(); });
  }
  function readState(parent) {
    var nodes = parent.querySelectorAll('[data-nv-cart-state]');
    if (nodes.length) applyState(json(nodes[nodes.length - 1], null));
  }
  async function applyCode(box) {
    if (box.dataset.busy === 'true') return;
    var input = box.querySelector('[data-nv-code]');
    var button = box.querySelector('[data-nv-apply-code]');
    var status = box.querySelector('[data-nv-code-status]');
    var code = input.value.trim();
    if (!code) { status.textContent = string('codeEmpty'); input.focus(); return; }
    if (code.includes(',')) { status.textContent = string('codeRejected'); return; }
    box.dataset.busy = 'true'; button.disabled = true; input.readOnly = true; status.textContent = '';
    var checkoutButtons = Array.from(document.querySelectorAll('.cart__checkout')).map(function (el) { return [el, el.disabled]; });
    checkoutButtons.forEach(function (entry) { entry[0].disabled = true; });
    var controller = new AbortController(); var timeout = setTimeout(function () { controller.abort(); }, 12000);
    try {
      var response = await fetch(shopURL(config.cartUrl + '/update.js'), { method: 'POST', credentials: 'same-origin', signal: controller.signal, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) });
      var cart = await response.json();
      if (!response.ok || cart.status >= 400) throw new Error('Discount update failed');
      var result = Core.codeStatus(cart, code);
      status.textContent = result === 'applied' ? string('codeApplied') : result === 'rejected' ? string('codeRejected') : string('codePending');
      // No client-calculated prices. Impulse reloads authoritative cart Liquid.
      document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (_) {
      status.textContent = string('codeError');
      document.dispatchEvent(new CustomEvent('cart:build'));
    } finally {
      clearTimeout(timeout); box.dataset.busy = 'false'; button.disabled = false; input.readOnly = false;
      checkoutButtons.forEach(function (entry) { if (entry[0].isConnected) entry[0].disabled = entry[1]; });
    }
  }
  function init(root) {
    rails.forEach(function (rail, el) { if (!el.isConnected) { rail.dispose(); rails.delete(el); } });
    document.querySelectorAll('[data-nv-recommendations]').forEach(function (el) { if (!rails.has(el)) rails.set(el, new Recommendations(el)); });
    document.querySelectorAll('#CartDrawerForm [data-products], #CartPageForm [data-products]').forEach(function (el) {
      if (observedForms.has(el)) return;
      observedForms.add(el);
      var observer = new MutationObserver(function () { readState(el); });
      observer.observe(el, { childList: true });
      readState(el);
    });
    var drawer = document.getElementById('CartDrawer');
    if (drawer && !boundDrawers.has(drawer)) {
      boundDrawers.add(drawer);
      new MutationObserver(function () { rails.forEach(function (rail) { rail.refresh(); }); }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    renderRewards();
  }
  document.addEventListener('click', function (event) {
    var apply = event.target.closest('[data-nv-apply-code]');
    if (apply) { event.preventDefault(); applyCode(apply.closest('[data-nv-coupon]')); }
    var tagged = event.target.closest('[data-nv-track]');
    if (tagged) track('nv_campaign_click', { placement: tagged.dataset.nvTrack });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target.matches('[data-nv-code]')) { event.preventDefault(); event.stopPropagation(); applyCode(event.target.closest('[data-nv-coupon]')); }
  });
  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-nv-tag-search]')) return;
    var term = Core.normalize(event.target.value);
    event.target.closest('[data-nv-filter-group]').querySelectorAll('[data-nv-tag-choice]').forEach(function (choice) { choice.hidden = !Core.normalize(choice.textContent).includes(term); });
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function () { setTimeout(function () { init(document); }, 0); });
  ['cart:open', 'ajaxProduct:added'].forEach(function (name) { document.addEventListener(name, function () { setTimeout(function () { rails.forEach(function (rail) { rail.refresh(); }); }, 0); }); });
  function headerSize() {
    var header = document.getElementById('SiteHeader');
    if (!header) return;
    document.documentElement.style.setProperty('--nv-header-height', Math.ceil(header.getBoundingClientRect().height) + 'px');
    if ('ResizeObserver' in window && !headerObserver) { headerObserver = new ResizeObserver(headerSize); headerObserver.observe(header); }
  }
  readState(document); init(document); headerSize();
  window.addEventListener('pageshow', function (event) { if (event.persisted) document.dispatchEvent(new CustomEvent('cart:build')); });
  window.NuevartCommerce = { version: '1.0.0', refresh: function () { document.dispatchEvent(new CustomEvent('cart:build')); } };
})();
